import React from 'react';

const printIcon = (icon: string | React.ReactNode, className?: string) => (
    typeof icon === 'string' ?
        <i className={`${icon} ${className}`}></i> : icon
)

const printTitleNode = (title:  iconTitle) => (
        <div className="d-flex align-items-center"> {printIcon(title.icon, "card-title-icon me-3")} &nbsp; {title.label} </div>
)

type iconTitle = {
    icon?: string | React.ReactNode,
    label: string
}

type BodyWrapperProps = {
    title:  iconTitle
    children: React.ReactNode
    footer: React.ReactNode
    style?: React.CSSProperties
}

export const BodyWrapper = ({title, children: body, footer = <></>, style={},} : BodyWrapperProps) => {
return (            <div style={style} className={'app-container'}>
                {/* begin::Row */}
                <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
                    {/* begin::Col */}
                    <div className='col-xxl-12'>
                        <div className="card card-custom card-flush">
                            <div className="card-header">
                                <h3 className="card-title">
                                    {printTitleNode(title)}
                                </h3>
                            </div>
                            <div className="card-body">
                                {body}
                            </div>
                            <div className="card-footer">
                                {footer}
                            </div>
                        </div>
                    </div>
                    {/* end::Col */}
                </div>
                {/* end::Row */}
            </div>
            )
}

export default BodyWrapper;
